import { Component, OnInit,OnDestroy,  ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';
import { TamasAlunoService } from '../tamas-aluno.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { AlertaSimplesDialog } from '../alerta-simples';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';

@Component({
  selector: 'app-me-perfil-local',
  templateUrl: './me-perfil-local.component.html',
  styleUrls: ['./me-perfil-local.component.css']
})
export class MePerfilLocalComponent implements OnInit {
  hideCL: boolean = false;
  listaCidades: any[] = [];
  listaUF: any[] = [];
  ufSelecionado: any = '';
  showDDC: any = false;
  qUF: any = '';
  qCidade: any = '';
  myControl = new FormControl();
  myControl2 = new FormControl();
  filteredOptions: Observable<string[]>;
  filteredOptions2: Observable<string[]>;
  ufSelecionadoN: any = '';
  cidadeSelecionadaN: any = '';
  constructor(private route: ActivatedRoute, private _location: Location, public router: Router, public tmaService: TamasAlunoService, public dialog: MatDialog) { }

  ngOnInit() {
    this.hideCL = false;
    //this.tmaService.eventoFS(true);
    this.tmaService.getJsonBR("")
    .subscribe((qRes) =>{
      console.log(qRes);
      this.hideCL = true;
      this.listaUF = qRes['estados'];
      this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );
    })
    // this.listaUF.push({uf: 'SP' },{uf: 'SP' },{uf: 'SP' },{uf: 'SP' },{uf: 'SP' },{uf: 'SP' },{uf: 'SP' },{uf: 'SP' },{uf: 'SP' },{uf: 'SP' },{uf: 'SP' },{uf: 'SP' },{uf: 'SP' },{uf: 'SP' });
    // this.listaCidades.push({nome: 'Campinas'}, {nome: 'Hortolândia'}, {nome: 'Sumaré'});
    
  }

  ngAfterViewInit() {
   
  }
  ngOnDestroy(){
    console.log("destroy");
    //this.tmaService.eventoFS(false);
  }

  changeUF() :void{
    console.log("alterou");
    this.listaCidades = [];
    console.log(this.qUF);
    this.hideCL = false;
    //realizar busca no servidor
    this.tmaService.getJsonUF(this.qUF)
    .subscribe((qRes) =>{
      console.log(qRes);
      this.listaCidades = qRes['cidades'];
      this.hideCL = true;
    })
    
    //this.listaCidades = 
    this.showDDC = true;
  }

  changeUFn(siglaUF: any) :void{
    this.hideCL = false;
    this.showDDC = true;
    console.log("foi");
    this.tmaService.getJsonUF(siglaUF)
    .subscribe((qRes) =>{
      console.log(qRes);
      this.listaCidades = qRes['cidades'];
      
      this.cidadeSelecionadaN = '';
      
      this.filteredOptions2 = this.myControl2.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter2(value))
      );
      this.hideCL = true;
    })
  }


  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.listaUF.filter(option => option.id.toLowerCase().includes(filterValue));
  }

  private _filter2(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.listaCidades.filter(option => option.cidade.toLowerCase().includes(filterValue));
  }



  voltar() :void{
    //this._location.back();
    if(this.tmaService.gUrlAnterior == 'validar'){
      const notEmptyallowerdd = this.dialog.open(AlertaSimplesDialog, {
        width: '300px',
        data: {tituloAlerta: "Aviso", textoAlerta: "Você deve informar o estado e a cidade para prosseguir com seu cadastro", textoConfirm: "Ok"}
      });
    }
    else{
      this.router.navigate(['/me/perfil']);
    }
  }

  salvar() :void{
    //verificar url anterior
    if(this.ufSelecionadoN == '' || this.cidadeSelecionadaN == ''){
      const notEmptyallowerdd = this.dialog.open(AlertaSimplesDialog, {
        width: '300px',
        data: {tituloAlerta: "Aviso", textoAlerta: "Você deve informar o estado e a cidade para continuar", textoConfirm: "Ok"}
      });
      return;
    }
    else{
      //enviar para servidor
      this.hideCL = false;
      var cidadePesq = this.modifiers(this.cidadeSelecionadaN);
      var dadosIn = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&uf=' + this.ufSelecionadoN + '&cidade=' + cidadePesq;
      this.tmaService.altUsuarioLocal(dadosIn)
      .subscribe((qRes) =>{
        console.log(qRes);
        if(qRes['res'] == 'done'){
         //após salvar, faz o redirect
          if(this.tmaService.gUrlAnterior == 'validar'){
            //continuar cadastro
            this.router.navigate(['/me/foto']);
          }
          else{
            //volta ao perfil
            this.router.navigate(['/me/perfil']);
          }
        }
      });
    

    }
  }

  modifiers(s: any): any{
    var r=s.toLowerCase();
    //r = r.replace(new RegExp("\\s", 'g'),"");
    r = r.replace(new RegExp("[àáâãäå]", 'g'),"a");
    r = r.replace(new RegExp("æ", 'g'),"ae");
    r = r.replace(new RegExp("ç", 'g'),"c");
    r = r.replace(new RegExp("[èéêë]", 'g'),"e");
    r = r.replace(new RegExp("[ìíîï]", 'g'),"i");
    r = r.replace(new RegExp("ñ", 'g'),"n");                            
    r = r.replace(new RegExp("[òóôõö]", 'g'),"o");
    r = r.replace(new RegExp("œ", 'g'),"oe");
    r = r.replace(new RegExp("[ùúûü]", 'g'),"u");
    r = r.replace(new RegExp("[ýÿ]", 'g'),"y");
    //r = r.replace(new RegExp("\\W", 'g'),"");
    return r;
};

}
